<template>
  
  <v-flex xs12 row>
    <v-layout py-3>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            
            <autocomplete label="Time Period" search-key="type" v-model="filter.period" :items="$options.periods" />
            
            <date-picker 
              v-if="filter.period === 'monthly'" 
              v-model="filter.year_month" 
              :min="minDateFrom" 
              :max="maxDate" 
              label="Year & Month" 
              class="mr-3" 
              type="month" 
            />

            <date-picker 
              v-else 
              v-model="filter.date_from" 
              :min="minDateFrom" 
              :max="maxDate" 
              :label="dateFromLabel" 
              class="mr-3" 
            />

            <date-picker 
              v-if="hasDateTo" 
              v-model="filter.date_to" 
              :disabled="!isDateToEditable"
              :min="minDateTo" 
              :max="maxDateTo" 
              label="Date To" 
              class="mr-3"
            />

            <autocomplete
              async
              clearable
              v-model="filter.item"
              label="Item Code"
              sub-title="title"
              search-key="item_code"
              key="itemByCode"
              :api-path="config.apis.searchItems"
            />
            
            <search-btn @click="loadReport" />

            <v-spacer></v-spacer>

          </v-card-title>
          
          <data-table
            :headers="headers"
            :items="processedItems"
            :loading="processing"
            :title="resultTitle"
            :sheet-name="sheetName"
            hide-actions
            download
          ></data-table>

      </v-card>
      </v-flex>
    </v-layout>
    
  </v-flex>
  
</template>

<script>

  import { reports } from '../../config/apis'

  import reportMixin from '../../mixins/reports'

  import DataTable from '../../components/DataTable'
  import DatePickerDialog from '../../components/DatePickerDialog'

  export default {
    
    components: {
      'data-table': DataTable,
      'date-picker': DatePickerDialog,
    },

    mixins: [ 
      reportMixin,
    ],

    data () {
      return {
        title: "Production Report",
        reportsApiPath: reports.production,
        filter: {
          period: "daily",
          date_from: this.today('YYYY-MM-DD'),
          date_to: '',
          year_month: '',
          item: null
        },
        hasDateWiseReport: false,
      }
    },

    computed: {
    	
      processedItems() {
          
        return this.items.map(item => {
          return {
            date: item.date,
            item_code: item.item_code,
            item_name: item.item_name,
            quantity: item.quantity,
            category_name: item.category_name,
            brand_name: item.brand_name,
            unit_name: item.unit_name,
            factory_name: item.factory_name,
          }
        })
        
      },

    },

    created () {

      this.$options.itemWiseHeaders = [
        { text: 'Production Date', value: 'date', sortable: false},
        { text: 'Item Code', value: 'item_code', sortable: false},
        { text: 'Item Name', value: 'item_name', sortable: false},
        { text: 'Quantity', value: 'quantity', sortable: false, align: 'right'},
        { text: 'Category', value: 'category_name', sortable: false},
        { text: 'Brand', value: 'brand_name', sortable: false},
        { text: 'Unit', value: 'unit_name', sortable: false},
        { text: 'Factory', value: 'factory_name', sortable: false},
      ]

    },

  }
</script>
